import { ChangeEvent, useEffect, useState } from "react";
import styled from "styled-components";
import { LinkList } from "../models/post";
import { AddListItemButton, ListActionRow, ListItem } from "../views/list-component";
import List from "../components/list";

const ListLink = styled.input`
  appearance: none;
  background: white;
  font-size: .9rem;
  font-weight: 600;
  padding: .25rem .75rem;
  width: 100%;
  font-style: italic;
  border: none;
  color: #328bff;
  &::placeholder {
    font-weight: bold;
    color: rgb(200,200,200);
  }
  &:focus {
    outline: none;
  }
`;

export function LinkListComponent(props: {
  linkList: LinkList;
  update: (items: { text: string; link: string; }[]) => void;
  deleteContent: () => void;
}) {

  const [items, setItems] = useState(props.linkList.items);

  const addItem = () => {
    setItems(items => [...items, { text: "", link: "" }]);
  };

  const deleteItem = () => {
    if (items.length === 0) {
      props.deleteContent();
      return;
    }
    setItems(i => {
      const copy = [...i];
      copy.pop();
      return copy;
    });
  };

  const onChangeText = (index: number) => (e: ChangeEvent<HTMLInputElement>) => {
    setItems(items => {
      const copy = [...items];
      copy[index].text = e.target.value;
      return copy;
    });
  };

  const onChangeLink = (index: number) => (e: ChangeEvent<HTMLInputElement>) => {
    setItems(items => {
      const copy = [...items];
      copy[index].link = e.target.value;
      return copy;
    });
  };

  useEffect(() => {
    props.update(items);
  }, [items, props]);

  return <List>
    {items.map((item, index) => <div key={index}>
      <ListItem value={item.text} placeholder="Eintragtitel..." onChange={onChangeText(index)} />
      <ListLink value={item.link} placeholder="Link..." onChange={onChangeLink(index)} />
    </div>)}
    <ListActionRow>
      <AddListItemButton onClick={deleteItem} style={{
        color: "#e92b54"
      }}>
        {items.length === 0 ? "Liste" : "Eintrag"} löschen
      </AddListItemButton>
      <AddListItemButton onClick={addItem} style={{
        color: "#1eb167"
      }}>
        Eintrag hinzufügen
      </AddListItemButton>
    </ListActionRow>
  </List>;
}
